// @ts-nocheck

import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as multiviewActionCreators from '../../actions/multiview';
import * as userActionCreators from '../../actions/user';
import useMergeProps from '../../hooks/useMergeProps';

import MultiviewModalBlockPicker from './MultiviewModalBlockPicker';
import selectMultiviewModalBlockPickerProps from './MultiviewModalBlockPicker.selector';

type MultiviewModalBlockPickerContainerProps = {
  className?: string;
};

const MultiviewModalBlockPickerContainer = (ownProps: MultiviewModalBlockPickerContainerProps) => {
  const dispatch = useDispatch();
  const [selectedSportId, setSelectedSportId] = useState(0);

  const selectorProps = useMemo(() => ({ selectedSportId }), [selectedSportId]);
  const selectedProps = useSelector((state) => selectMultiviewModalBlockPickerProps(state, selectorProps));

  const delMatch = useCallback(
    (matchId: number) => {
      dispatch(multiviewActionCreators.delMatch(matchId));
    },
    [dispatch],
  );

  const addMatch = useCallback(
    (matchId: number) => {
      dispatch(multiviewActionCreators.addMatch(matchId));
    },
    [dispatch],
  );

  const setScrollToHeaderOnTheNextShowMatchList = useCallback(
    (value: boolean) => {
      dispatch(multiviewActionCreators.setScrollToHeaderOnTheNextShowMatchList(value));
    },
    [dispatch],
  );

  const setShowWinamaxTv = useCallback(
    (value) => {
      dispatch(userActionCreators.setShowWinamaxTv(value));
    },
    [dispatch],
  );

  const otherProps = useMemo(
    () => ({
      selectedSportId,
      setSelectedSportId,
      delMatch,
      addMatch,
      setScrollToHeaderOnTheNextShowMatchList,
      setShowWinamaxTv,
    }),
    [
      selectedSportId,
      setSelectedSportId,
      delMatch,
      addMatch,
      setScrollToHeaderOnTheNextShowMatchList,
      setShowWinamaxTv,
    ],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MultiviewModalBlockPicker {...enhancedProps} />;
};

export default MultiviewModalBlockPickerContainer;
